import clsx from 'clsx';
import { Slider as SliderPrimitive, Tooltip } from 'radix-ui';
import { forwardRef, useState } from 'react';
import { SliderRuler } from './SliderRuler';
import styles from './styles.module.css';

const HubertSlider = forwardRef<
  React.ComponentRef<typeof SliderPrimitive.Root>,
  React.ComponentPropsWithoutRef<typeof SliderPrimitive.Root>
>(({ ...props }, ref) => {
  const [leftOpen, setLeftOpen] = useState(false);
  const [rightOpen, setRightOpen] = useState(false);

  return (
    <div className="flex w-[300px] flex-col gap-1">
      <SliderPrimitive.Root
        ref={ref}
        className="relative flex h-5 w-full touch-none items-center select-none"
        {...props}
      >
        <SliderPrimitive.Track
          className={clsx(
            styles.sliderTrackDisabled,
            'relative',
            'h-0.5 w-full',
            'grow overflow-hidden',
            'rounded-full bg-gray-200',
          )}
        >
          <SliderPrimitive.Range
            className={clsx(
              styles.sliderTrackDisabled,
              'rounded-full',
              'absolute h-full',

              'bg-gray-400',
            )}
          />
        </SliderPrimitive.Track>

        <Tooltip.Provider>
          <Tooltip.Root open={leftOpen}>
            <Tooltip.Trigger asChild>
              <SliderPrimitive.Thumb
                className={clsx(
                  styles.sliderThumbDisabled,
                  'block h-4 w-4',
                  'border-primary/50 rounded-full border bg-gray-600',
                  'shadow transition-colors',
                  // focus-visible:
                  'focus-visible:ring-1 focus-visible:outline-none',
                  'focus-visible:ring-ring',
                  // disabled:
                  'disabled:pointer-events-none disabled:opacity-50',
                  'disabled:bg-gray-300',
                  'cursor-pointer',

                  'border border-indigo-500 bg-white',
                )}
                onPointerDown={() => setLeftOpen(true)}
                onPointerUp={() => setLeftOpen(false)}
                onFocus={() => setLeftOpen(true)}
                onBlur={() => setLeftOpen(false)}
                onMouseEnter={() => setLeftOpen(true)}
                onMouseLeave={() => setLeftOpen(false)}
              />
            </Tooltip.Trigger>
            <Tooltip.Content side="top" align="center" className="rounded bg-black px-2 py-1 text-sm text-white">
              {props.value ? props.value[0] : 0}
              <Tooltip.Arrow className="fill-black" />
            </Tooltip.Content>
          </Tooltip.Root>
        </Tooltip.Provider>

        <Tooltip.Provider>
          <Tooltip.Root open={rightOpen}>
            <Tooltip.Trigger asChild>
              <SliderPrimitive.Thumb
                className={clsx(
                  styles.sliderThumbDisabled,
                  'block h-4 w-4',
                  'border-primary/50 rounded-full border bg-gray-600',
                  'shadow transition-colors',
                  // focus-visible:
                  'focus-visible:ring-1 focus-visible:outline-none',
                  'focus-visible:ring-ring',
                  // disabled:
                  'disabled:pointer-events-none disabled:opacity-50',
                  'disabled:bg-gray-300',
                  'cursor-pointer',

                  'border border-indigo-500 bg-white',
                )}
                onPointerDown={() => setRightOpen(true)}
                onPointerUp={() => setRightOpen(false)}
                onFocus={() => setRightOpen(true)}
                onBlur={() => setRightOpen(false)}
                onMouseEnter={() => setRightOpen(true)}
                onMouseLeave={() => setRightOpen(false)}
              />
            </Tooltip.Trigger>
            <Tooltip.Content side="top" align="center" className="rounded bg-black px-2 py-1 text-sm text-white">
              {props.value && props.value.length === 2 ? props.value[1] : 0}
              <Tooltip.Arrow className="fill-black" />
            </Tooltip.Content>
          </Tooltip.Root>
        </Tooltip.Provider>
      </SliderPrimitive.Root>
      {props.value !== undefined ? (
        <SliderRuler min={props.min ?? 0} max={props.max ?? 10} value={props.value} />
      ) : null}
    </div>
  );
});

HubertSlider.displayName = 'HubertSlider';

export { HubertSlider };
